@import "../../variables.scss";

.optionsbutton {
  &__wrapper {
    border-radius: 4px;
    justify-content: space-between;
    border: 1px solid $color-info;
    @media (max-width: $size-md) {
      flex-direction: column;
    }
  }
  &__pickable {
    width: 100%;
    display: flex;
    justify-content: center;
    padding: 0.5rem 0rem;
    cursor: pointer;
    transition: 0.2s background-color;
    border-left: $color-info 1px solid;
    @media (max-width: $size-md) {
      border-left: none;
      border-top: $color-info 1px solid;
    }
    &:hover {
      background-color: #b7e7ff;
    }
  }
  &__picked {
    color: white;
    background-color: $color-info !important;
  }
  &__disabled {
    pointer-events: none;
  }
}
